import { useEffect } from "react";
import { Link } from "react-router-dom";

const LAST_UPDATE = "2 de Setembro de 2026";

const C = {
  bg: "#FFFFFF",
  bgSoft: "#F8FAFC",
  bgDark: "#122457",
  primary: "#2563EB",
  text: "#0F172A",
  textMuted: "#475569",
  border: "#E2E8F0",
};

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: "2.5rem" }}>
      <h2 style={{ fontWeight: 800, fontSize: "1.3rem", color: C.text, marginBottom: "1rem", paddingBottom: "0.5rem", borderBottom: `1px solid ${C.border}` }}>{title}</h2>
      <div style={{ color: C.textMuted, fontSize: "0.93rem", lineHeight: 1.8 }}>{children}</div>
    </div>
  );
}

function P({ children }) {
  return <p style={{ marginBottom: "0.85rem" }}>{children}</p>;
}

function Ul({ items }) {
  return (
    <ul style={{ paddingLeft: "1.25rem", marginBottom: "0.85rem", display: "flex", flexDirection: "column", gap: "0.4rem" }}>
      {items.map((item, i) => <li key={i}>{item}</li>)}
    </ul>
  );
}

export default function PrivacidadePage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div style={{ background: C.bg, color: C.text, fontFamily: "'Inter', sans-serif", minHeight: "100vh" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');`}</style>

      {/* Nav simples */}
      <nav style={{ position: "sticky", top: 0, zIndex: 100, background: "rgba(255,255,255,0.95)", backdropFilter: "blur(16px)", borderBottom: `1px solid ${C.border}`, padding: "1rem clamp(1.5rem,5vw,4rem)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Link to="/" style={{ display: "flex", alignItems: "center", gap: "0.5rem", fontWeight: 900, fontSize: "1.25rem", color: C.text, textDecoration: "none" }}>
          <span style={{ width: 30, height: 30, borderRadius: 8, background: C.primary, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: "0.95rem", fontWeight: 900 }}>R</span>
          RUMO
        </Link>
        <Link to="/" style={{ color: C.textMuted, textDecoration: "none", fontSize: "0.85rem", fontWeight: 600, display: "flex", alignItems: "center", gap: "0.4rem" }}>
          ← Voltar ao site
        </Link>
      </nav>

      {/* Hero */}
      <div style={{ background: `linear-gradient(160deg, ${C.bgDark} 0%, #0B1533 100%)`, padding: "4rem clamp(1.5rem,5vw,4rem) 3rem", color: "#fff" }}>
        <div style={{ maxWidth: 760, margin: "0 auto" }}>
          <p style={{ fontSize: "0.72rem", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "#93C5FD", marginBottom: "0.75rem" }}>Legal</p>
          <h1 style={{ fontWeight: 800, fontSize: "clamp(2rem,5vw,3rem)", letterSpacing: "-0.01em", marginBottom: "0.75rem" }}>Política de Privacidade</h1>
          <p style={{ color: "#B9C6E8", fontSize: "0.88rem" }}>Última atualização: {LAST_UPDATE}</p>
        </div>
      </div>

      {/* Content */}
      <div style={{ maxWidth: 760, margin: "0 auto", padding: "3.5rem clamp(1.5rem,5vw,4rem) 5rem" }}>

        <Section title="1. Quem somos">
          <P>A <strong style={{ color: C.text }}>RUMO</strong> é uma plataforma de gestão de frota desenvolvida em Portugal, disponível em <strong style={{ color: C.text }}>www.rumo-frota.pt</strong>.</P>
          <P>Para qualquer questão relacionada com privacidade e proteção de dados, pode contactar-nos através de: <a href="mailto:geral@rumo-frota.pt" style={{ color: C.primary }}>geral@rumo-frota.pt</a></P>
        </Section>

        <Section title="2. Que dados recolhemos">
          <P>Recolhemos apenas os dados estritamente necessários para prestar o serviço:</P>
          <P><strong style={{ color: C.text }}>Através do formulário de contacto / pedido de demonstração:</strong></P>
          <Ul items={["Nome", "Email", "Telefone (opcional)", "Nome da empresa (opcional)", "Dimensão da frota (opcional)", "Mensagem (opcional)"]} />
          <P><strong style={{ color: C.text }}>Através da plataforma (clientes):</strong></P>
          <Ul items={["Dados de registo: nome, email, empresa", "Dados operacionais introduzidos: viaturas, manutenções, combustível, condutores, entre outros", "Registos de acesso, para efeitos de segurança"]} />
        </Section>

        <Section title="3. Como utilizamos os dados">
          <P>Os dados recolhidos são utilizados exclusivamente para:</P>
          <Ul items={[
            "Responder a pedidos de informação e demonstrações",
            "Prestar o serviço contratado",
            "Enviar comunicações relacionadas com o serviço",
            "Melhorar a plataforma com base em feedback",
            "Cumprir obrigações legais",
            "Garantir a segurança da plataforma"
          ]} />
          <P><strong style={{ color: C.text }}>Não vendemos, partilhamos nem cedemos os seus dados a terceiros para fins comerciais.</strong></P>
        </Section>

        <Section title="4. Base legal do tratamento">
          <P>O tratamento dos dados pessoais baseia-se em:</P>
          <Ul items={[
            "Consentimento — ao preencher o formulário de contacto",
            "Execução de contrato — para clientes da plataforma",
            "Interesse legítimo — para segurança e melhoria do serviço",
            "Obrigação legal — quando aplicável"
          ]} />
        </Section>

        <Section title="5. Onde e como guardamos os dados">
          <P>Os dados são armazenados em infraestrutura cloud segura, alojada na União Europeia. Todas as comunicações com a plataforma são encriptadas, e os dados são igualmente protegidos enquanto armazenados.</P>
          <P>São realizadas cópias de segurança automáticas diárias. O acesso aos dados é restrito a pessoal autorizado da RUMO, e cada empresa cliente vê exclusivamente os seus próprios dados.</P>
        </Section>

        <Section title="6. Durante quanto tempo guardamos os dados">
          <Ul items={[
            "Pedidos de contacto: no máximo 24 meses, ou até ser solicitada a sua eliminação",
            "Dados de clientes ativos: durante toda a vigência do contrato",
            "Dados após cancelamento: 90 dias disponíveis para exportação, findo os quais são eliminados de forma permanente",
            "Registos de segurança: 12 meses"
          ]} />
        </Section>

        <Section title="7. Os seus direitos (RGPD)">
          <P>Ao abrigo do Regulamento Geral de Proteção de Dados (RGPD), tem os seguintes direitos:</P>
          <Ul items={[
            "Acesso — consultar os dados que temos sobre si",
            "Retificação — corrigir dados incorretos ou incompletos",
            "Eliminação — solicitar a eliminação dos seus dados",
            "Portabilidade — receber os seus dados num formato estruturado",
            "Oposição — opor-se ao tratamento dos seus dados",
            "Limitação — solicitar a limitação do tratamento"
          ]} />
          <P>Para exercer qualquer um destes direitos, contacte-nos: <a href="mailto:geral@rumo-frota.pt" style={{ color: C.primary }}>geral@rumo-frota.pt</a>. Respondemos no prazo máximo de 30 dias.</P>
          <P>Tem também o direito de apresentar reclamação junto da <strong style={{ color: C.text }}>CNPD</strong> (Comissão Nacional de Proteção de Dados): <a href="https://www.cnpd.pt" target="_blank" rel="noreferrer" style={{ color: C.primary }}>www.cnpd.pt</a></P>
        </Section>

        <Section title="8. Cookies e rastreamento">
          <P>O site <strong style={{ color: C.text }}>não utiliza cookies de rastreamento</strong> nem ferramentas de publicidade ou análise de comportamento de terceiros.</P>
          <P>São utilizados apenas os cookies estritamente necessários para o funcionamento da plataforma, como manter a sessão de um utilizador autenticado.</P>
        </Section>

        <Section title="9. Segurança">
          <P>Implementamos medidas de segurança adequadas à proteção dos seus dados, entre as quais:</P>
          <Ul items={[
            "Encriptação de todas as comunicações com a plataforma",
            "Encriptação dos dados armazenados",
            "Autenticação segura de cada utilizador",
            "Acesso restrito: cada empresa vê apenas os seus próprios dados",
            "Proteção contra registos automáticos indevidos no formulário de contacto",
            "Cópias de segurança automáticas diárias"
          ]} />
        </Section>

        <Section title="10. Alterações a esta política">
          <P>Reservamo-nos o direito de atualizar esta política sempre que necessário. Alterações significativas serão comunicadas por email aos clientes ativos. A data da última atualização está sempre visível no topo desta página.</P>
        </Section>

        <Section title="11. Contacto">
          <P>Para qualquer questão sobre privacidade e proteção de dados:</P>
          <P><strong style={{ color: C.text }}>RUMO — Gestão de Frota</strong><br />
          Email: <a href="mailto:geral@rumo-frota.pt" style={{ color: C.primary }}>geral@rumo-frota.pt</a><br />
          Website: <a href="https://www.rumo-frota.pt" style={{ color: C.primary }}>www.rumo-frota.pt</a></P>
        </Section>

        <div style={{ marginTop: "3rem", paddingTop: "2rem", borderTop: `1px solid ${C.border}`, display: "flex", gap: "1.5rem", flexWrap: "wrap" }}>
          <Link to="/" style={{ color: C.textMuted, textDecoration: "none", fontSize: "0.85rem" }}>← Voltar ao site</Link>
          <Link to="/termos" style={{ color: C.primary, textDecoration: "none", fontSize: "0.85rem" }}>Ver Termos e Condições →</Link>
        </div>
      </div>
    </div>
  );
}
